import { Organization } from '../global';

export const EXTRNL_REPORT_ORGANIZATION_SEARCH = 'EXTRNL_REPORT_ORGANIZATION_SEARCH';
export const EXTRNL_REPORT_ORGANIZATION_SEARCH_RESULT = 'EXTRNL_REPORT_ORGANIZATION_SEARCH_RESULT';
export const REPORT_ORGANIZATION_TYPE = 'REPORT_ORGANIZATION_TYPE';
export const REPORT_ORG_INCLUDE_CHILD = 'REPORT_ORG_INCLUDE_CHILD';
export const SUBMIT_EXTRNL_REPORT_FORM = 'SUBMIT_EXTRNL_REPORT_FORM';
export const RESET_REPORT_FORM = 'RESET_REPORT_FORM';

export interface ExternalReportOrganizationData {
  reportOrganizations?: Organization[];
  formValues?: { [key: string]: [value: string] };
  isFormSubmitted?: Boolean
}
